import React from 'react';
import CryptoJS from 'crypto-js';

export function toInitials(name, limit = 2) {
  return (
    name &&
    name
      .split(' ')
      .map((s) => s && s[0]) // take first letter
      .join('')
      .slice(0, limit)
      .toUpperCase()
  );
}

export function toStartCase(camelCase) {
  return (
    camelCase &&
    camelCase
      .replace(/^([A-Z])/, (first) => first.toLowerCase()) // ensure camelCase
      .replace(/[A-Z]+/g, (cap) => ` ${cap}`) // split at each uncontiguous upper case letter
      .replace(/^([a-z])/, (first) => first.toUpperCase()) // upper case the first letter
  );
}

export function toSnakeCase(phrase) {
  return (
    phrase &&
    toStartCase(phrase) // handle camel case
      .replace(/[^\w\d]+/g, '_') // remove special chars
      .toLowerCase()
  );
}

export function encrypt(text) {
  return CryptoJS.SHA1(text).toString().toUpperCase();
}

export function toRGB(str, initial) {
  return str
    .split('')
    .map((c) => c.charCodeAt(0))
    .reduce(
      (rgb, c) => [
        (rgb[0] * c) % 256,
        (rgb[0] + rgb[1] * c) % 256,
        (rgb[1] + rgb[2] * c) % 256,
      ],
      initial || [127, 127, 127]
    );
}

export function toColor(name, opacity) {
  const [r, g, b] = toRGB(name);
  return `rgba(${r},${g},${b},${opacity || 1})`;
}

function componentToHex(component) {
  var hex = component.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}
function lightenComponent(colorVal, increment) {
  const lightColor = parseInt(colorVal, 16) + increment;
  return lightColor < 255 ? lightColor : 255;
}

export function lightenColor(hex, increment) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `#${result
        .slice(1, result.length)
        .reduce(
          (colorCode, component) =>
            `${colorCode}${componentToHex(
              lightenComponent(component, increment)
            )}`,
          ''
        )}`
    : null;
}

export const textFormatter = (string) => {
  return string.split(/(\*-[A-z0-9]+-\*)/g).map((subStr) => {
    if (/(\*-[A-z0-9]+-\*)/g.test(subStr)) {
      return (
        <span style={{ fontWeight: 'bold' }}>
          {(subStr || '').replace(/\*-|-\*/g, '')}
        </span>
      );
    }
    return subStr;
  });
};

export const spaceRemover = (string) => {
  return string.replace(/\s/g, '');
};

export const newLineSplitter = (text) => {
  return text.split('\n');
};

export const getInRupeesFormat = (price) => {
  price = price.toString();
  let lastThree = price.substring(price.length - 3);
  let otherNumbers = price.substring(0, price.length - 3);
  if (otherNumbers != '') lastThree = ',' + lastThree;
  let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
  return res;
};
